import React from 'react';
import Navbar from '../HomeComponent/Navbar';
import FooterComponent from '../Footer/FooterComponent';

const Pricing = () => {
    const plans = [
        {
            name: "Starter",
            price: "$49",
            features: ["1 AI Agent", "500 Minutes/mo", "Basic Analytics", "Email Support"],
            recommended: false
        },
        {
            name: "Growth",
            price: "$149",
            features: ["3 AI Agents", "2,000 Minutes/mo", "Advanced Analytics", "Priority Support", "CRM Integration"],
            recommended: true
        },
        {
            name: "Enterprise",
            price: "Custom",
            features: ["Unlimited Agents", "Unlimited Minutes", "Custom LLM Training", "Dedicated Success Manager", "SLA"],
            recommended: false
        }
    ];

    return (
        <>
            <Navbar />
            <div style={{ paddingTop: '80px', minHeight: '100vh', background: '#f8fafc', paddingBottom: '40px' }}>
                <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', padding: '0 20px' }}>
                    <h1 style={{ fontSize: '3rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '10px' }}>
                        Simple, Transparent Pricing
                    </h1>
                    <p style={{ fontSize: '1.2rem', color: '#64748b', marginBottom: '50px' }}>
                        Choose the plan that fits your business needs. No hidden fees.
                    </p>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '30px' }}>
                        {plans.map((plan, index) => (
                            <div key={index} style={{
                                background: plan.recommended ? '#ffffff' : '#f1f5f9',
                                border: plan.recommended ? '2px solid #8B5CF6' : '1px solid #e2e8f0',
                                borderRadius: '16px',
                                padding: '40px',
                                boxShadow: plan.recommended ? '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)' : 'none',
                                position: 'relative',
                                display: 'flex',
                                flexDirection: 'column'
                            }}>
                                {plan.recommended && (
                                    <span style={{
                                        position: 'absolute',
                                        top: '-12px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        background: '#8B5CF6',
                                        color: 'white',
                                        padding: '4px 12px',
                                        borderRadius: '20px',
                                        fontSize: '0.875rem',
                                        fontWeight: 'bold'
                                    }}>
                                        Most Popular
                                    </span>
                                )}
                                <h3 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1e293b', marginBottom: '10px' }}>{plan.name}</h3>
                                <div style={{ fontSize: '2.5rem', fontWeight: 'bold', color: '#8B5CF6', marginBottom: '20px' }}>{plan.price}<span style={{ fontSize: '1rem', color: '#64748b', fontWeight: 'normal' }}>/mo</span></div>
                                <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 30px 0', textAlign: 'left', flexGrow: 1 }}>
                                    {plan.features.map((feat, i) => (
                                        <li key={i} style={{ marginBottom: '10px', color: '#475569', display: 'flex', alignItems: 'center' }}>
                                            <span style={{ color: '#10b981', marginRight: '10px' }}>✓</span> {feat}
                                        </li>
                                    ))}
                                </ul>
                                <button style={{
                                    width: '100%',
                                    padding: '12px',
                                    borderRadius: '8px',
                                    border: 'none',
                                    background: plan.recommended ? '#8B5CF6' : '#1e293b',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                    transition: 'background 0.3s'
                                }}>
                                    Get Started
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <FooterComponent />
        </>
    );
};

export default Pricing;
